<template>
    <div class="main-content row mx-0">
        <div 
            class="col-12 col-sm-8 col-md-9"
            :class="{'pr-0' : $breakpoint.lgAndDown && !$breakpoint.xsOnly }"
        >
            <div class="row mb-4">
                <div class="col-md-12">
                    <live-terminal-view/>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-md-12">
                    <live-prices/>
                </div>
            </div>
            <order-history class="mb-4" />
            <div class="row mb-4">
                <div class="col-md-12">
                    <h2 class="first-header heading-medium">
                        <i class="fas fa-calendar-check mr-2" ></i>Selling Report
                    </h2>
                    <volumes-per-product class="card" />
                </div>
            </div>
        </div>
        <div class="col-12 col-sm-4 col-md-3">
            <div class="d-flex justify-content-end">
            <refresh-information style="white-space: nowrap;"/>
            </div>
            <h2 class="first-header">Tools</h2>
            <div class="tools">
                <market-change class="mb-4" />
                <dashboard-graphs class="mb-4" />
                <negotiations-tool class="mb-4" />
            </div>
        </div>
    </div>
</template>

<script>
import breakpoint from '@/mixins/index';
import LiveTerminalView from './LiveTerminalTables/LiveTerminalView.vue';
import LivePrices from '@/pages/Views/Seller/LivePrices/LivePrices.vue';
import OrderHistory from '@/pages/Purchase/PurchaseHistory.vue';
import DashboardGraphs from '@/components/Graphs/DashboardGraphs.vue';
import MarketChange from '@/components/Tools/MarketChange.vue';
import NegotiationsTool from '@/components/Tools/NegotiationsTool.vue';
import VolumesPerProduct from '@/components/Graphs/VolumesPerProduct.vue';
import RefreshInformation from '@/components/RefreshInformation.vue';

const { detect } = require('detect-browser');

export default {
    mixins: [breakpoint],
    components:{
        DashboardGraphs,
        MarketChange,
        LiveTerminalView,
        LivePrices,
        OrderHistory,
        NegotiationsTool,
        VolumesPerProduct,
        RefreshInformation
    },
    data(){
        return {
            browser: detect()
        }
    },
}
</script>

